import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  container: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr ",
    gap: "60px",
    width: "100%",
    overflowX: "auto",

    [theme.breakpoints.down("lg")]: {
      gap: "24px",
    },

    [theme.breakpoints.down("md")]: {
      gap: "48px",
    },

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      display: "flex",
      gap: "24px",
    },
  },
  panel: {
    borderRadius: 16,
    flex: 1,
    textAlign: "center",
    border: "1px solid #000000",
    backgroundColor: "rgba(28, 30, 31)",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    padding: "24px 32px",

    "&>p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
      color: "#FFFFFF",
    },

    [theme.breakpoints.down("lg")]: {
      padding: "24px 24px",
    },
  },
  title: {
    marginBottom: "15px",
    fontWeight: "bold",
    fontSize: "18px",
  },
  infoText: {
    margin: "5px 0",
    fontFamily: "Philosopher",
    fontWeight: 900,
    color: "#888",
  },
  greenText: {
    color: "#28a745",
  },
  redText: {
    color: "#dc3545",
  },
  ownerLink: {
    color: theme.palette.text.linkColor,
    cursor: "pointer",
    textDecoration: "none",
  },
  image: {
    width: "100px",
    borderRadius: "8px",
    objectFit: "cover",
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
    padding: "0 8px",
  },

  infoLabel: {
    color: theme.palette.text.secondary,
    fontSize: "14px",
    fontFamily: "Philosopher",
    fontWeight: 700,
  },

  infoValue: {
    color: theme.palette.text.primary,
    fontSize: "14px",
    fontFamily: "Philosopher",
    fontWeight: 700,
    textAlign: "right",
  },
  rankInfos: {
    maxHeight: 160,
    overflow: "auto",
    padding: "0 16px 0 0",
  },

  details: {
    display: "flex",
    gap: "24px",
    alignItems: "flex-start", // Changed to align-items: flex-start
  },

  claimButton: {
    backgroundColor: "rgb(40, 127, 209)",
    color: "#fff",
    border: "none",
    borderRadius: "16px",
    padding: "4px 24px",
    cursor: "pointer",
    fontFamily: "Philosopher",
    fontWeight: 900,
    textTransform: "none",

    "&:disabled": {
      backgroundColor: "rgb(23, 24, 25)",
      cursor: "not-allowed",
    },
  },
}));

export default styles;
